/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';
import type { TransactionsTransactionIn } from './TransactionsTransactionIn';
import {
    TransactionsTransactionInFromJSON,
    TransactionsTransactionInFromJSONTyped,
    TransactionsTransactionInToJSON,
} from './TransactionsTransactionIn';

/**
 * 
 * @export
 * @interface GetMoneyInChequeDetailsOutput
 */
export interface GetMoneyInChequeDetailsOutput {
    /**
     * 
     * @type {TransactionsTransactionIn}
     * @memberof GetMoneyInChequeDetailsOutput
     */
    transactions?: TransactionsTransactionIn;
    /**
     * 
     * @type {Links}
     * @memberof GetMoneyInChequeDetailsOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof GetMoneyInChequeDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetMoneyInChequeDetailsOutput interface.
 */
export function instanceOfGetMoneyInChequeDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInChequeDetailsOutputFromJSON(json: any): GetMoneyInChequeDetailsOutput {
    return GetMoneyInChequeDetailsOutputFromJSONTyped(json, false);
}

export function GetMoneyInChequeDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInChequeDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionInFromJSON(json['transactions']),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetMoneyInChequeDetailsOutputToJSON(value?: GetMoneyInChequeDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionInToJSON(value.transactions),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

